import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import { BrowserRouter, HashRouter } from "react-router-dom";
import store from './app/store/store';
import { Provider } from 'react-redux';
// import reportWebVitals from './reportWebVitals';
import { Buffer } from 'buffer';

if (!window.Buffer) {
  window.Buffer = Buffer;
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter >
        <App />
      </HashRouter >
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
